<div class="carta-img-izq">
  <img [ngClass]="{'img-1': imgTamano == 1, 'img-2': imgTamano == 2} " src={{imagen}} alt="">
  <p class="texto" [ngClass]="{'ml-3': imgTamano == 2}">{{descripcion}}</p>
</div>
